import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/plays.php
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length || !global.userIndex.length) return
		var sql = 'SELECT game_id, user_id, SUM(play_count) as total_plays, SUM(play_length) as total_duration, MAX(play_date) as last_play, MIN(play_date) as first_play FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ') GROUP BY game_id, user_id'
		if (global.context && global.context.edition && global.context.edition.date_end) {
			sql = 'SELECT game_id, user_id, SUM(play_count) as total_plays, SUM(play_length) as total_duration, MAX(play_date) as last_play, MIN(play_date) as first_play FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ') AND play_date <= ' + global.context.edition.date_end + ' GROUP BY game_id, user_id'
		}
		var rows = DB.query(sql)
		global.gamePlays = global.gamePlays || {}
		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!global.gamePlays[r.game_id]) global.gamePlays[r.game_id] = {}
			global.gamePlays[r.game_id][r.user_id] = r
		}
		// Context plays if active
		if (global.context && global.context.plays) {
			var ctxSql = 'SELECT game_id, user_id, SUM(play_count) as total_plays, SUM(play_length) as total_duration, MAX(play_date) as last_play, MIN(play_date) as first_play FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ')'
			if (global.context.plays.from) ctxSql += ' AND play_date >= ' + global.context.plays.from
			if (global.context.plays.to) ctxSql += ' AND play_date <= ' + global.context.plays.to
			ctxSql += ' GROUP BY game_id, user_id'
			var ctxRows = DB.query(ctxSql)
			global.context.plays.data = {}
			for (var j = 0; j < ctxRows.length; j++) {
				var cr = ctxRows[j]
				if (!global.context.plays.data[cr.game_id]) global.context.plays.data[cr.game_id] = {}
				global.context.plays.data[cr.game_id][cr.user_id] = cr
			}
		}
	}
}
